(function(angular) {
    'use strict';

    angular.module('onvio.setup.appearance').controller('SignInOptionsCtrl', signInOptions);
    signInOptions.$inject = [
        '$rootScope',
        '$q',
        '$translate',
        'AuthenticatedSessionData',
        'bluemoon.components.Notifications',
        'ThemeSetupManager',
        'bmTheme',
        'bmAccess',
        '$sce'
    ];

    function signInOptions($rootScope, $q, $translate, sessionData, Notifications, themeManager, bmTheme, bmAccess, $sce) {
        /*jshint validthis:true */
        this.$onInit = function() {
            var vm = this;
            var firmSettings;

            vm.options = vm.optionsData;
            vm.selectBackground = selectBackground;
            vm.saveSettings = saveSettings;
            vm.resetSettings = resetSettings;
            vm.isBrazil = false;

            // Create method publicly available through 2-way data bound object
            vm.options.setSignInDirty = function() {
                // TODO: UPDATE METHOD ONCE WEB SERVICE IS CORRECT
                vm.options.hasUnsavedSignIn = vm.signInSettingsForm.$dirty || vm.selected.name !== vm.options.firmSettings.loginBackground;
            };

            var promises = [
                themeManager.getFormattedLoginHtml(),
                themeManager.getApplicationRootUrl()
            ];

            $q.all(promises).then(function(results) {
                vm.onvioSigninHTML = $sce.trustAsHtml(results[0].staff.trim());
                vm.clientCenterSigninHTML = $sce.trustAsHtml(results[0].client.trim());
                vm.rootUrl = results[1];
                initData();
            });

            //////////////

            function initData() {
                var backgroundName = angular.copy(vm.options.firmSettings.loginBackground);
                var signoutUrl = angular.copy(vm.options.firmSettings.logoutUrl);

                // setup default background list
                vm.backgrounds = angular.copy(themeManager.signInBackgrounds);
                vm.selected = vm.backgrounds[0];

                var firmBackground = vm.backgrounds.filter(function(background) {
                    if (angular.isUndefined(backgroundName) || backgroundName === '') {
                        return false;
                    }

                    return background.name === backgroundName;
                });

                if (firmBackground.length > 0) {
                    selectBackground(firmBackground[0]);
                }

                vm.signoutUrl = angular.isDefined(signoutUrl) ? signoutUrl : '';
            }

            vm.copyToClipboard = function(code) {
                if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
                    const textarea = document.createElement('textarea');
                    textarea.textContent = code;
                    textarea.style.position = 'fixed';
                    document.body.appendChild(textarea);
                    textarea.select();
                    try {
                        document.execCommand('copy');
                    } finally {
                        document.body.removeChild(textarea);
                    }
                }
            };

            function selectBackground(background) {
                vm.selected.active = false;
                background.active = true;
                vm.selected = background;
            }

            function resetNotifications() {
                Notifications.setError(null);
                Notifications.setInfo(null);
            }

            function saveSettings() {
                resetNotifications();

                // make sure form is valid
                if (!getFormFieldValidity()) {
                    $translate('onvio.setup.appearance.invalidSignoutUrl').then(function(value) {
                        Notifications.setError(value);
                    });

                    return;
                }

                var theme = getThemeFromUserEntry(true);

                $rootScope.$emit('bm-busy-loading-on');

                var companyId = sessionData.bindings.ApplicationConfiguration.CompanyId;
                resetNotifications();
                var promises = [
                    themeManager.saveTheme(companyId, theme)
                ];
                return $q.all(promises).then(function() {
                    $rootScope.$emit('bm-busy-loading-off');
                    $rootScope.$emit('scollViewTop');
                    vm.signInSettingsForm.$setPristine();
                    vm.options.hasUnsavedSignIn = false;

                    // persist data
                    vm.options.firmSettings.loginBackground = theme.loginBackground;
                    vm.options.firmSettings.logoutUrl = theme.logoutUrl;

                    $translate('Onvio.Setup.Theme.Success').then(function(value) {
                        Notifications.setInfo(value);
                    });

                    // refresh the theme so changes are picked up on other screens
                    bmTheme.load(companyId, undefined, true);
                }, function() {
                    $rootScope.$emit('bm-busy-loading-off');
                    $translate('Onvio.Setup.Theme.Error').then(function(value) {
                        Notifications.setError(value);
                    });
                });
            }

            function getFormFieldValidity() {
                // set form as dirty in order to display any validation messages
                vm.signInSettingsForm.$setSubmitted();
                return vm.signInSettingsForm.$valid;
            }

            function resetSettings() {
                resetNotifications();
                vm.signInSettingsForm.$setPristine();
                initData();
                vm.options.hasUnsavedSignIn = false;
                $rootScope.$emit('scollViewTop');
            }

            function getThemeFromUserEntry(refresh) {
                // start with theme as defined in options
                var theme = angular.isUndefined(firmSettings) || refresh ? getThemeFromOptions() : angular.copy(firmSettings);

                // from user entry
                theme.loginBackground = vm.selected.name;
                theme.logoutUrl = vm.signoutUrl;

                return theme;
            }

            function getThemeFromOptions() {
                var theme = {
                    colors: vm.options.firmSettings.colors,
                    headerImage: vm.options.firmSettings.headerImage,
                    headerLine1: vm.options.firmSettings.headerLine1
                };

                // don't lose other theme settings
                if (angular.isDefined(vm.options.firmSettings.id)) {
                    theme.id = vm.options.firmSettings.id;
                }

                return theme;
            }
        };
    }
})(window.angular);
